import React from 'react';
import { Link } from 'react-router-dom';

import { isExternal } from 'helpers/http';

import DropdownMenuNotification from 'components/layout/mainMenus/common/DropdownMenuNotification';

export default class MainMenuLinkNotification extends React.Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
  }

  onMouseEnter = () => {
    const { index, onMouseEnter } = this.props;
    onMouseEnter(index);
  };

  render() {
    const {
      flipId,
      index,
      currentIndex,
      layout,
      // prevIndex,
      onClick,
      hasDropdown,
      animatingOut,
      id,
      listClassName,
      className,
      link,
      text,
      dropdownWidth,
      icon,
    } = this.props;

    const isActive = index === currentIndex;
    // const wasActive = index === prevIndex;
    const isExternalLink = isExternal(link);
    const LinkComponent = isExternalLink ? 'a' : Link;
    const linkProps = {
      className: `ms-top-menu ${className || ''}`,
      to: (!isExternalLink && link) || undefined,
      href: (isExternalLink && link) || undefined,
      onMouseEnter: this.onMouseEnter,
      onClick: onClick || undefined,
    };

    let marginLeft = 0;
    if (hasDropdown && isActive && this.ref.current) {
      const buttonRect = this.ref.current.getBoundingClientRect();
      const dropdownWidthInPx = dropdownWidth; //(dropdownWidth / 100) * layout.width;
      let marginLeft = buttonRect.left;

      // Check if the dropdown extends out of the screen on the right
      if (buttonRect.left + dropdownWidthInPx > layout.width) {
        // If so, we move it to the left so that the right end of the dropdown is on the right edge of the screen
        marginLeft = layout.width - dropdownWidthInPx;
      } else if (marginLeft < 0) {
        // Optional: If the button itself is already on the left edge and the dropdown is wider, we can align it to the left edge.
        marginLeft = 0;
      }
    }

    return (
      <li
        key={"mainMenuLinkNotification" + id}
        className={`ms-top-menu ${listClassName || ''} ${isActive ? 'active' : ''}`}
        id={id || undefined}
        ref={this.ref}
      >
        <LinkComponent {...linkProps}>
          {icon}
          {text}
        </LinkComponent>
        {hasDropdown && isActive && (
          <DropdownMenuNotification
            flipId={flipId}
            index={index}
            element={this.props}
            visible={isActive}
            animatingOut={animatingOut}
            marginLeft={marginLeft}
          />
        )}
      </li>
    );
  }
}
